// @flow
import { put, call, select } from 'redux-saga/effects';
import ApiNotifications from '~/sdk/notifications/email/ApiNotifications';
import { restoreSearchNotifications, setNotificationWeeklyFrequencySuccess } from '../actions';
import { notificationApiParamsSelector } from '../../selectors';
import { searchNotificationsSelector } from '../selectors';
import { openSnackbarError, closeSnackbar, openSnackbar } from '../../Snackbar/actions';
import { resolvedNotificationIdSelector } from '../../resolvedParams/selectors';
import messages from '../messages';
import { FREQUENCY_WEEKLY } from '../../constants';

export default (notificationsApi: ApiNotifications) =>
  function* setNotificationWeeklyFrequency(): Generator<*, *, *> {
    yield put(closeSnackbar());

    const searchNotifications = yield select(searchNotificationsSelector);
    const apiParams = yield select(notificationApiParamsSelector);
    const notificationId = yield select(resolvedNotificationIdSelector);

    const currentNotification = searchNotifications.find(
      notification => notification.id === notificationId
    );

    const newFrequency = FREQUENCY_WEEKLY;
    const newNotification = { ...currentNotification, frequency: newFrequency, active: true };

    // Eager user response with full rollback on error
    yield put(setNotificationWeeklyFrequencySuccess(newNotification));

    try {
      yield call(
        [notificationsApi, notificationsApi.updateSearchNotificationFrequency],
        apiParams,
        notificationId,
        newFrequency
      );

      yield put(openSnackbar(messages.notificationUpdated));
    } catch (error) {
      yield put(openSnackbarError());
      yield put(restoreSearchNotifications(searchNotifications));
    }
  };



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/SearchNotifications/sagas/setNotificationWeeklyFrequency.js